export default __webpack_public_path__ + "static/media/product-image-hover-11.796622d1.jpg";